import React from "react";

/**
 * Simple loading indicator using design system styles.
 *
 * Props:
 * - size: "sm" | "md" | "lg" (currently only "md" is styled)
 * - className: extra class names (applied to wrapper)
 * - ariaLabel: accessible label for screen readers
 */
export function Loader({ size = "md", className = "", ariaLabel = "Loading" }) {
  const wrapperClasses = ["rm-loader-wrap"];
  if (className) {
    wrapperClasses.push(className);
  }

  const spinnerClasses = ["rm-loader"];
  if (size) {
    spinnerClasses.push(`rm-loader--${size}`);
  }

  return (
    <span
      className={wrapperClasses.join(" ").trim()}
      role="status"
      aria-live="polite"
      aria-label={ariaLabel}
    >
      <span className={spinnerClasses.join(" ").trim()} />
    </span>
  );
}

export default Loader;
